import { atom } from 'jotai'

import { gridStateAtomFamily, Entry } from './gridStateFamilyAtom'

const replaceElementAt = (arr: any[], value, index) => {
  return [...arr.slice(0, index), value, ...arr.slice(index + 1)]
}

const swapPositions = (arr: any[], pos1, pos2) => {
  const val1 = arr[pos1]
  const val2 = arr[pos2]

  return replaceElementAt(replaceElementAt(arr, val2, pos1), val1, pos2)
}

export const setColumnPositionAtom = atom<null, { id: string; field: string; position: number }>(
  null,
  (get, set, { id, field, position }) => {
    const gridStateAtom = gridStateAtomFamily(id)

    const normalizedPosition = position - 1

    const entry = get(gridStateAtom)

    const actualPosition = entry.orders.findIndex((i) => i === field)

    const nextEntry = {
      ...get(gridStateAtom),
      orders: swapPositions(entry.orders, normalizedPosition, actualPosition),
    } as Entry

    set(gridStateAtom, nextEntry)
  },
)
